import { render, staticRenderFns } from "./GridIsActive.vue?vue&type=template&id=a032bfe0&"
import script from "./GridIsActive.vue?vue&type=script&lang=js&"
export * from "./GridIsActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports